var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowHeaderUserlevel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 247,
    viewBox: "0 0 478 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.791 183.406L449.727 129.547L415.873 129.547L432.791 183.406Z",
    fill: "#FFC444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.096 129.862C372.096 129.471 372.251 129.097 372.527 128.82C372.803 128.544 373.178 128.389 373.568 128.389L452.952 128.389C453.342 128.389 453.717 128.544 453.993 128.82C454.269 129.097 454.424 129.471 454.424 129.862C454.424 130.055 454.386 130.246 454.311 130.424C454.237 130.601 454.129 130.763 453.992 130.898C453.855 131.034 453.692 131.141 453.514 131.213C453.335 131.285 453.144 131.321 452.952 131.319L373.568 131.319C373.375 131.321 373.184 131.285 373.006 131.213C372.827 131.141 372.665 131.034 372.528 130.898C372.391 130.763 372.283 130.601 372.208 130.424C372.134 130.246 372.096 130.055 372.096 129.862Z",
    fill: "#D89609"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.236 90.5561L268.236 89.3143L183.858 89.3143L183.858 90.5561L268.236 90.5561Z",
    fill: "url(#paint0_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M477.627 65.5222L477.627 64.2804L349.488 64.2804L349.488 65.5221L477.627 65.5222Z",
    fill: "url(#paint1_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M352.615 188.805L352.615 187.563L272.603 187.563L272.603 188.805L352.615 188.805Z",
    fill: "url(#paint2_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M280.736 14.8411L280.736 13.5994L176.346 13.5994L176.346 14.8411L280.736 14.8411Z",
    fill: "url(#paint3_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.834 1.69683L113.834 0.455078L46.3245 0.455075L46.3245 1.69683L113.834 1.69683Z",
    fill: "url(#paint4_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.6 247.001L272.6 245.759L116.329 245.759L116.329 247.001L272.6 247.001Z",
    fill: "url(#paint5_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.834 202.562L158.834 201.32L112.576 201.32L112.576 202.562L158.834 202.562Z",
    fill: "url(#paint6_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M456.375 230.725L456.375 229.484L303.859 229.484L303.859 230.725L456.375 230.725Z",
    fill: "url(#paint7_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.098 233.226L125.098 231.984L25.7188 231.984L25.7188 233.226L125.098 233.226Z",
    fill: "url(#paint8_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M425.117 89.9269L425.117 88.6852L350.728 88.6852L350.728 89.9269L425.117 89.9269Z",
    fill: "url(#paint9_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M365.744 37.3605L365.744 36.1188L301.36 36.1188L301.36 37.3605L365.744 37.3605Z",
    fill: "url(#paint10_linear_1_2915)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000454981 111.403L0.000454257 127.96L60.2826 127.96L186.702 64.2995L282.607 64.2995L282.607 47.7428L182.766 47.7428L56.363 111.403L0.000454981 111.403Z",
    fill: "#B0A579"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M275.364 80.7892L318.215 56.0204L275.364 31.2515L275.364 80.7892Z",
    fill: "#B0A579"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00025853 117.876L104.539 187.431L204.91 187.431L204.91 170.874L109.534 170.874L0.000259399 97.9916L0.00025853 117.876Z",
    fill: "#B0A579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.683 203.922L240.518 179.154L197.683 154.385L197.683 203.922Z",
    fill: "#B0A579"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315.502 179.367L401.187 129.829L315.502 80.3078L315.502 113.272L162.374 113.272L90.1346 66.8968L0.000701904 66.8968L0.000700457 100.01L80.4431 100.01L152.666 146.386L315.502 146.386L315.502 179.367Z",
    fill: "url(#paint11_linear_1_2915)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.24436e-05 169.302L80.5581 227.284L248.488 227.284L248.488 210.727L85.9 210.727L-9.15527e-05 148.921L-9.24436e-05 169.302Z",
    fill: "#B0A579"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M241.245 243.774L284.096 219.005L241.245 194.237L241.245 243.774Z",
    fill: "#B0A579"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.93 38.207L152.93 21.6503L-0.000228882 21.6503L-0.000229606 38.207L152.93 38.207Z",
    fill: "#B0A579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.687 54.6967L188.521 29.9278L145.687 5.15893L145.687 54.6967Z",
    fill: "#B0A579"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2915",
    x1: 183.841,
    y1: 89.9269,
    x2: 268.22,
    y2: 89.9269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2915",
    x1: 349.488,
    y1: 64.9095,
    x2: 477.627,
    y2: 64.9096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2915",
    x1: 272.603,
    y1: 188.176,
    x2: 352.615,
    y2: 188.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2915",
    x1: 176.33,
    y1: 14.212,
    x2: 280.72,
    y2: 14.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2915",
    x1: 46.3245,
    y1: 1.06768,
    x2: 113.834,
    y2: 1.06768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2915",
    x1: 116.329,
    y1: 246.372,
    x2: 272.6,
    y2: 246.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2915",
    x1: 112.576,
    y1: 201.95,
    x2: 158.834,
    y2: 201.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2915",
    x1: 303.859,
    y1: 230.113,
    x2: 456.375,
    y2: 230.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2915",
    x1: 25.7023,
    y1: 232.613,
    x2: 125.081,
    y2: 232.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2915",
    x1: 350.728,
    y1: 89.3143,
    x2: 425.117,
    y2: 89.3143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2915",
    x1: 301.344,
    y1: 36.7479,
    x2: 365.728,
    y2: 36.7479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#030302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1C1A13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#332F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#504A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#736C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9C926A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7BA87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2915",
    x1: 384.418,
    y1: 123.14,
    x2: 37.9396,
    y2: 123.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E2DE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHeaderUserlevel);
export default __webpack_public_path__ + "static/media/arrow_header_userlevel.ce33f9a48c2470cdac3e77a3efc49a13.svg";
export { ForwardRef as ReactComponent };